import React from "react";
import ReactPlayer from 'react-player/lazy';
import useWindowWide from "./useWindowWide";
import { Box, Container } from '@mui/material';

const styleCentered = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '75%',
  maxWidth: '1100px',
  bgcolor: 'black',
  boxShadow: 24,
};

const styleDefault = {
  width: '100%',
  maxWidth: '1100px',
  bgcolor: '#FFF5F8',
  m: 'auto',
  mt: 5,
  p: 2,
};

const desktopVideoUrl = 'https://youtu.be/ovK_MeWLGts';
const mobileVideoUrl = 'https://youtu.be/VHUF0_ojzMo';

export default function Video({ modal }) {
  const isWide = useWindowWide(750);

  let style = modal ? styleCentered : styleDefault;

  const customStyle = {
    ...style, 
    aspectRatio: isWide ? '15/8.425' : '8.5/15',
  };

  return (
    <Container maxWidth="md" sx={{ flexGrow: 1, p: 2 }}>
      <Box sx={customStyle}>
        <ReactPlayer 
          width="100%"
          height="100%"
          url={isWide ? desktopVideoUrl : mobileVideoUrl} 
          playing
          controls
        />
      </Box>
    </Container>
  );
}